import React from 'react';
import { Pagination } from 'react-bootstrap';

const CustomPagination = ({ totalPage, currentPage, onPageChange }) => {
    const paginationItems = [];

    // Define the range of pages to show
    const startPage = Math.max(currentPage - 2, 1);
    const endPage = Math.min(currentPage + 2, totalPage);

    // Add first page and ellipsis if needed
    if (startPage > 1) {
        paginationItems.push(
            <Pagination.Item key={1} active={currentPage === 1} onClick={() => onPageChange(1)}>
                {1}
            </Pagination.Item>
        );
        if (startPage > 2) {
            paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
        }
    }

    // Add the range of pages
    for (let page = startPage; page <= endPage; page++) {
        paginationItems.push(
            <Pagination.Item key={page} active={currentPage === page} onClick={() => onPageChange(page)}>
                {page}
            </Pagination.Item>
        );
    }

    // Add last page and ellipsis if needed
    if (endPage < totalPage) {
        if (endPage < totalPage - 1) {
            paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
        }
        paginationItems.push(
            <Pagination.Item key={totalPage} active={currentPage === totalPage} onClick={() => onPageChange(totalPage)}>
                {totalPage}
            </Pagination.Item>
        );
    }

    return <Pagination>{paginationItems}</Pagination>;
};

export default CustomPagination;
